/**
 * Galde Theme JavaScript
 * Shopify 2.0 theme for Galde skincare brand
 * Migrated from Remix/React - pure vanilla JS, no dependencies
 */

(function () {
  'use strict';

  /* ---------- Mobile nav toggle ---------- */
  var burger = document.querySelector('.mobile-nav__burger');
  if (burger) {
    burger.addEventListener('click', function () {
      var menu = document.getElementById('mobile-menu');
      var open = menu.style.display !== 'none';
      menu.style.display = open ? 'none' : 'block';
      burger.setAttribute('aria-expanded', String(!open));
      burger.querySelector('.mobile-nav__burger-open').style.display = open ? '' : 'none';
      burger.querySelector('.mobile-nav__burger-close').style.display = open ? 'none' : '';
    });
  }

  /* ---------- Newsletter popup ---------- */
  var popup = document.querySelector('.newsletter-popup');
  if (popup) {
    // Show after short delay if not previously dismissed
    if (!localStorage.getItem('newsletterPopDismissed')) {
      setTimeout(function () {
        popup.style.display = '';
      }, 3000);
    }

    var closeBtn = popup.querySelector('.newsletter-popup__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        popup.style.display = 'none';
        localStorage.setItem('newsletterPopDismissed', 'true');
      });
    }
  }

  /* ---------- Cart notification ---------- */
  var notification = document.querySelector('.cart-notification');
  var notificationTimer = null;

  function updateCartCount(count) {
    document.querySelectorAll('.js-cart-count').forEach(function (el) {
      el.textContent = count;
    });
  }

  function showCartNotification(item) {
    if (!notification) return;
    var img = notification.querySelector('.cart-notification__image img');
    var name = notification.querySelector('.cart-notification__name');
    if (img && item.image) {
      img.src = item.image;
      img.alt = item.title || '';
    }
    if (name) name.textContent = item.title || item.product_title || '';
    notification.style.display = '';
    clearTimeout(notificationTimer);
    var duration = parseInt(notification.dataset.duration, 10) || 10000;
    notificationTimer = setTimeout(function () {
      notification.style.display = 'none';
    }, duration);
  }

  function hideCartNotification() {
    if (!notification) return;
    notification.style.display = 'none';
    clearTimeout(notificationTimer);
  }

  if (notification) {
    var closeEl = notification.querySelector('.cart-notification__close');
    if (closeEl) {
      closeEl.addEventListener('click', hideCartNotification);
    }
    notification.querySelectorAll('.cart-notification__action').forEach(function (a) {
      a.addEventListener('click', hideCartNotification);
    });
  }

  /* ---------- AJAX add-to-cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.getAttribute('action') !== '/cart/add') return;
    e.preventDefault();

    var data = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: data
    })
      .then(function (res) { return res.json(); })
      .then(function (item) {
        // Update cart count
        fetch('/cart.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) { updateCartCount(cart.item_count); });
        // Show notification
        showCartNotification(item);
      });
  });

  /* ---------- AJAX cart page ---------- */
  var cartPage = document.getElementById('cart-page');
  if (cartPage) {
    function formatMoney(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'en', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' EUR';
    }

    function changeQuantity(key, delta) {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var item = cart.items.find(function (i) { return i.key === key; });
          if (!item) return;
          var newQty = item.quantity + delta;
          if (newQty < 1) newQty = 1;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: newQty })
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          refreshCartPage(cart);
        });
    }

    function removeFromCart(key) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          refreshCartPage(cart);
        });
    }

    function refreshCartPage(cart) {
      if (cart.item_count === 0) {
        cartPage.innerHTML =
          '<div class="cart-empty">' +
            '<div class="cart-empty__title">' + cartPage.dataset.emptyText + '</div>' +
            '<a href="/pages/shop">' + cartPage.dataset.shopText + ' →</a>' +
          '</div>';
        return;
      }

      var itemsHtml = '';
      var featuredImages = {};
      cartPage.querySelectorAll('.cart-item[data-featured-image]').forEach(function (el) {
        featuredImages[el.dataset.key] = el.dataset.featuredImage;
      });

      cart.items.forEach(function (item) {
        var fi = featuredImages[item.key];
        var imgSrc = fi || (item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_600x$1$2') : '');
        var fiAttr = fi ? ' data-featured-image="' + fi.replace(/"/g, '&quot;') + '"' : '';
        itemsHtml +=
          '<div class="cart-item" data-key="' + item.key + '"' + fiAttr + '>' +
            '<a href="' + item.url + '" class="cart-item__image">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.title.replace(/"/g, '&quot;') + '" />' : '') +
            '</a>' +
            '<div class="cart-item__data">' +
              '<a href="' + item.url + '" class="cart-item__line">' + item.product_title + '</a>' +
              '<div class="cart-item__line">' +
                cartPage.dataset.qtyText +
                ' <span class="cart-item__qty-btn js-qty-minus">-</span>' +
                ' <span class="cart-item__qty-value">' + item.quantity + '</span>' +
                ' <span class="cart-item__qty-btn js-qty-plus">+</span>' +
              '</div>' +
              '<div class="cart-item__footer">' +
                '<div class="cart-item__line cart-item__line--link js-remove-item">' + cartPage.dataset.deleteText + '</div>' +
                '<div class="cart-item__price cart-item__price--mobile">' + formatMoney(item.final_line_price) + '</div>' +
              '</div>' +
            '</div>' +
            '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
          '</div>';
      });

      cartPage.innerHTML =
        '<div class="cart">' +
          '<div class="cart__items">' + itemsHtml + '</div>' +
          '<div class="cart__footer">' +
            '<div class="cart__footer-body">' +
              '<div class="cart__checkout-lines">' +
                '<div class="cart__checkout-line"><div>' + cartPage.dataset.subtotalText + '</div><div>' + formatMoney(cart.total_price) + '</div></div>' +
                '<div class="cart__checkout-line"><div>' + cartPage.dataset.shippingText + '</div><div>' + cartPage.dataset.shippingAtCheckout + '</div></div>' +
              '</div>' +
              '<div class="cart__checkout-lines">' +
                '<div class="cart__checkout-line"><div>' + cartPage.dataset.totalText + '</div><div>' + formatMoney(cart.total_price) + '</div></div>' +
              '</div>' +
            '</div>' +
            '<div class="cart__checkout-note">' + cartPage.dataset.taxNote + '</div>' +
            '<div class="cart__checkout-btn"><a href="/checkout" class="cart__checkout">' + cartPage.dataset.checkoutText + '</a></div>' +
          '</div>' +
        '</div>';
    }

    cartPage.addEventListener('click', function (e) {
      var target = e.target;
      var item = target.closest('.cart-item');
      if (!item) return;
      var key = item.dataset.key;

      if (target.classList.contains('js-qty-minus')) {
        changeQuantity(key, -1);
      } else if (target.classList.contains('js-qty-plus')) {
        changeQuantity(key, 1);
      } else if (target.classList.contains('js-remove-item')) {
        removeFromCart(key);
      }
    });
  }

  /* ---------- Accordion toggle ---------- */
  document.querySelectorAll('.js-accordion-toggle').forEach(function (head) {
    head.addEventListener('click', function () {
      var body = head.nextElementSibling;
      var toggle = head.querySelector('.accordion__toggle');
      var isOpen = body.style.display !== 'none';

      // Desktop: close siblings first (one-at-a-time)
      if (window.innerWidth > 780) {
        var container = head.closest('.product-data__info');
        if (container) {
          container.querySelectorAll('.js-accordion-toggle').forEach(function (other) {
            if (other === head) return;
            var otherBody = other.nextElementSibling;
            var otherToggle = other.querySelector('.accordion__toggle');
            otherBody.style.display = 'none';
            if (otherToggle) otherToggle.textContent = '+';
          });
        }
      }

      body.style.display = isOpen ? 'none' : 'block';
      if (toggle) toggle.textContent = isOpen ? '+' : '-';
    });
  });

  /* ---------- Homepage hero rotation ---------- */
  /* Desktop: cookie cycles through standard → outline → collection.
     Mobile: always shows the mobile-only standard hero (CSS handles this).
     Desktop heroes are hidden by default; JS adds .is-active to the current one. */
  var heroSection = document.querySelector('.section-homepage-hero');
  if (heroSection) {
    var desktopHeroes = heroSection.querySelectorAll('.homepage-hero--desktop');
    var types = ['standard', 'outline', 'collection'];

    // Read current index from cookie
    var match = document.cookie.match(/(?:^|; )hero-type=(\d+)/);
    var heroIndex = match ? parseInt(match[1], 10) : 0;
    if (heroIndex > 2) heroIndex = 0;

    // Set next index in cookie for next page load
    var nextIndex = (heroIndex + 1) % types.length;
    document.cookie = 'hero-type=' + nextIndex + '; path=/; max-age=31536000; SameSite=Lax';

    var activeType = types[heroIndex];

    // Activate the matching desktop hero
    desktopHeroes.forEach(function (hero) {
      if (hero.dataset.heroType === activeType) {
        hero.classList.add('is-active');
      }
    });
  }

  /* ---------- Product slider ---------- */
  var slider = document.querySelector('[data-product-slider]');
  if (slider) {
    var track = slider.querySelector('[data-slider-track]');
    var slides = track.querySelectorAll('.product-slider__slide');
    var counter = slider.querySelector('[data-slider-counter]');
    var prevZone = slider.querySelector('[data-slider-prev]');
    var nextZone = slider.querySelector('[data-slider-next]');
    var cursorPrev = slider.querySelector('[data-slider-cursor-prev]');
    var cursorNext = slider.querySelector('[data-slider-cursor-next]');
    var currentSlide = 0;
    var totalSlides = slides.length;

    function goToSlide(index) {
      if (index < 0) index = totalSlides - 1;
      if (index >= totalSlides) index = 0;
      currentSlide = index;
      track.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
      counter.textContent = (currentSlide + 1) + ' / ' + totalSlides;

      // Manage video autoplay
      slides.forEach(function (slide, i) {
        var video = slide.querySelector('video');
        if (!video) return;
        if (i === currentSlide) {
          video.play();
        } else {
          video.pause();
        }
      });
    }

    if (prevZone) {
      prevZone.addEventListener('click', function () { goToSlide(currentSlide - 1); });
    }
    if (nextZone) {
      nextZone.addEventListener('click', function () { goToSlide(currentSlide + 1); });
    }

    // Custom cursor tracking
    function trackCursor(zone, cursorEl) {
      if (!zone || !cursorEl) return;
      zone.addEventListener('mouseenter', function () { cursorEl.style.display = 'block'; });
      zone.addEventListener('mouseleave', function () { cursorEl.style.display = 'none'; });
      zone.addEventListener('mousemove', function (e) {
        cursorEl.style.left = e.clientX + 'px';
        cursorEl.style.top = e.clientY + 'px';
      });
    }
    trackCursor(prevZone, cursorPrev);
    trackCursor(nextZone, cursorNext);

    // Touch swipe — detect direction, only slide on horizontal swipes
    var touchStartX = 0;
    var touchStartY = 0;
    var swiping = false;
    slider.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
      touchStartY = e.changedTouches[0].clientY;
      swiping = false;
    }, { passive: true });
    slider.addEventListener('touchmove', function (e) {
      if (swiping) {
        e.preventDefault();
        return;
      }
      var deltaX = Math.abs(e.changedTouches[0].clientX - touchStartX);
      var deltaY = Math.abs(e.changedTouches[0].clientY - touchStartY);
      if (deltaX > 10 || deltaY > 10) {
        swiping = deltaX > deltaY;
      }
    }, { passive: false });
    slider.addEventListener('touchend', function (e) {
      if (!swiping) return;
      var deltaX = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(deltaX) > 40) {
        if (deltaX > 0) {
          goToSlide(currentSlide - 1);
        } else {
          goToSlide(currentSlide + 1);
        }
      }
    }, { passive: true });

    // Pause non-active videos on load
    slides.forEach(function (slide, i) {
      var video = slide.querySelector('video');
      if (video && i !== 0) video.pause();
    });
  }

})();
